import type { PapelUsuario } from '@/contratos'

export interface ItemNav {
  titulo: string
  rota: string
  icone:
    | 'auditoria'
    | 'fila'
    | 'gestao_nc'
    | 'ficha'
    | 'nc'
    | 'usuario'
    | 'prestadora'
    | 'dashboard'
    | 'pressao'
    | 'publico'
    | 'midia'
    | 'auditoria_log'
  papeis: PapelUsuario[]
}

export interface SecaoNav {
  secao: string
  itens: ItemNav[]
}

export const NAVEGACAO: SecaoNav[] = [
  {
    secao: 'Fiscalização',
    itens: [
      { titulo: 'Minhas Auditorias', rota: '/auditorias', icone: 'auditoria', papeis: ['fiscal', 'gerente', 'admin'] },
      { titulo: 'Gestão de NCs', rota: '/ncs', icone: 'gestao_nc', papeis: ['fiscal', 'gerente', 'admin'] },
      { titulo: 'Fila de Aprovação', rota: '/aprovacoes', icone: 'fila', papeis: ['gerente', 'admin'] },
    ],
  },
  {
    secao: 'Indicadores',
    itens: [
      { titulo: 'Painel Interno', rota: '/dashboard', icone: 'dashboard', papeis: ['fiscal', 'gerente', 'admin'] },
      { titulo: 'Pressão', rota: '/pressao', icone: 'pressao', papeis: ['fiscal', 'gerente', 'admin'] },
      { titulo: 'Painel Público', rota: '/publico', icone: 'publico', papeis: ['fiscal', 'gerente', 'admin'] },
    ],
  },
  {
    secao: 'Administração',
    itens: [
      { titulo: 'Fichas de Inspeção', rota: '/admin/fichas', icone: 'ficha', papeis: ['admin'] },
      { titulo: 'Catálogo de NCs', rota: '/admin/ncs', icone: 'nc', papeis: ['admin'] },
      { titulo: 'Cadastros de Usuário', rota: '/admin/usuarios', icone: 'usuario', papeis: ['admin'] },
      { titulo: 'Prestadoras e Sistemas', rota: '/admin/prestadoras', icone: 'prestadora', papeis: ['admin'] },
      { titulo: 'Acervo de Evidências', rota: '/admin/midias', icone: 'midia', papeis: ['admin'] },
      { titulo: 'Trilha de Auditoria', rota: '/admin/auditoria', icone: 'auditoria_log', papeis: ['admin'] },
    ],
  },
]

export function navegacaoDo(papel: PapelUsuario): SecaoNav[] {
  return NAVEGACAO.map((s) => ({ ...s, itens: s.itens.filter((i) => i.papeis.includes(papel)) })).filter(
    (s) => s.itens.length > 0,
  )
}
